import { geminiTrainingNote, RECIPE_LINK_NOTE } from '../lib/privacy';

/**
 * What AI features send to Google Gemini, in full. Setup, You and every AI feature's "agree"
 * prompt show this same text, and the README and .env.example describe it, so it stays complete:
 * update it whenever a feature sends something new.
 */
export function GeminiPrivacy({ paidTier }: { paidTier: boolean }) {
  return (
    <div className="small stack" style={{ gap: 6 }}>
      <p>
        AI features send Google Gemini only what each one needs: your food descriptions and photos, food names and grams from your log, daily totals and
        what's left of your targets, dated weigh-ins (and which one is your starting weight), profile basics (sex, age, height, activity, goal and
        targets), your Coach conversation, restaurant menus you paste or photograph for What fits, and recipes you import (the ingredient list, pasted
        recipe text, a recipe page's text, title and site name, or a recipe photo or screenshot). It never gets your account's name or email, but text you
        paste, screenshots and recipe pages are sent as they are. Photos and screenshots are shrunk and stripped of
        location data in your browser and are never stored. {RECIPE_LINK_NOTE} A barcode photo is read on your device when it can be; if not, the picture
        is sent to Gemini to read the digits and is not stored. In Chrome, Edge and Safari, voice input is transcribed by the browser's speech service,
        which may send the audio to Google or Apple. In Brave and Firefox, or when that service fails, a short clip is sent to Gemini to transcribe and is
        not stored.
      </p>
      <p>
        {geminiTrainingNote(paidTier)} There's no HIPAA agreement in place, so keep this to your own data — never anyone else's health information.
      </p>
    </div>
  );
}

/** Where the log is kept, for setup's "AI and your data" step. */
export function WhereYourLogLives({ signInOn }: { signInOn: boolean }) {
  return signInOn ? (
    <p className="small">
      Your log is stored on this server under your account. The person who runs it sees your name, emails, last visit and AI use, and can technically read
      anything stored here. Other members see nothing of yours but recipes you share by link.
    </p>
  ) : (
    <p className="small">
      Your log stays on this computer (<code>data/grams.db</code>).
    </p>
  );
}
